"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _mdiMaterialUi = require("mdi-material-ui");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _AccountAvatar = _interopRequireDefault(require("../AccountAvatar/AccountAvatar"));
var _TeamMembers = _interopRequireDefault(require("./TeamMembers.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// COMPONENTS

// ASSETS

var TeamMembers = function TeamMembers(_ref) {
  var onClick = _ref.onClick,
    _users = _ref.users,
    _ref$hasExternal = _ref.hasExternal,
    hasExternal = _ref$hasExternal === void 0 ? true : _ref$hasExternal,
    _ref$additionalMember = _ref.additionalMembers,
    additionalMembers = _ref$additionalMember === void 0 ? 1 : _ref$additionalMember;
  // HOOKS
  var classes = (0, _TeamMembers.default)();
  var theme = (0, _styles.useTheme)();
  var screenLG = (0, _core.useMediaQuery)(theme.breakpoints.only('md'));

  // MISC
  var users = _users !== null && _users !== void 0 ? _users : [];
  var indexesToShow = screenLG ? 1 : 3;
  var usersToShow = users.filter(function (_, index) {
    return index <= indexesToShow;
  });
  var remainingUsers = users.length - usersToShow.length;

  // STYLES
  var addTeamMember = (0, _classnames.default)(classes.teamMembersListItem, classes.addTeamMembersListItem, classes.teamMembersSharedDimensions);
  var externalIcon = (0, _classnames.default)(classes.teamMembersListItem, classes.remainingMembers, classes.teamMembersSharedDimensions);
  return /*#__PURE__*/_react.default.createElement("ul", {
    onClick: onClick,
    className: classes.teamMembersList,
    role: "presentation"
  }, remainingUsers > 0 && /*#__PURE__*/_react.default.createElement("li", {
    className: classes.emailMembers
  }, "+", remainingUsers + additionalMembers), /*#__PURE__*/_react.default.createElement("li", {
    className: addTeamMember
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Plus, {
    className: classes.addPeopleSvg
  })), usersToShow.map(function (_ref2) {
    var id = _ref2.id,
      picture = _ref2.picture,
      displayName = _ref2.displayName;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: classes.teamMembersListItem,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_AccountAvatar.default, {
      className: classes.teamMembersSharedDimensions,
      src: picture,
      alt: "".concat(displayName, " avatar"),
      letter: displayName.charAt(0)
    }));
  }), hasExternal && /*#__PURE__*/_react.default.createElement("li", {
    className: externalIcon
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.EmailOutline, {
    fontSize: "small"
  })));
};
var _default = TeamMembers;
exports.default = _default;